import { createSelector } from 'reselect';
import selectProductDetailsBase from './selectProductDetailsBase';

export default createSelector([selectProductDetailsBase], (base) => base.id || '');
